import { ITranslation } from '@pec/aion-ui-core/interfaces/translation';

export interface IScoreResult {
  id: string;
  clientId: string;
  contractorId: string;
  scoreSetId: string;
  scoreSetName: string;
  scoreSetNameTranslations?: ITranslation[];
  scoreDateTimeUtc: string;
  totalPointsAvailable: number;
  totalPointsScored: number;
  calculatedScore: number;
  isActive: boolean;
  rankingColor: string;
  rankingDescription: string;
  rankTranslations?: ITranslation[];
  scoreSetRank: IScoreSetRanking;
  scoreOverride?: IScoreOverride | null;
  memberType?: MemberType;
}

export type MemberType = 'Prime' | 'Subcontractor' | 'Both';

export const MemberTypes: Record<MemberType, MemberType> = {
  Prime: 'Prime',
  Subcontractor: 'Subcontractor',
  Both: 'Both'
};

export interface IScoreOverride {
  id: string;
  clientId: string;
  contractorId: string;
  scoreSetId: string;
  scoreSetRankId: string;
  userName: string;
  comment: string;
  expirationDateTimeUtc: string;
  updatedDateTimeUtc?: string | null;
}

export interface IScoreSetRanking {
  id: string;
  rankingId: number;
  description: string;
  color: string;
  lowerBound: number;
  upperBound: number;
}

export interface IContractorOverallScore {
  id: string;
  rank: number;
  color: string;
  description: string;
  translations?: ITranslation[];
}

export interface IClientScoreResult {
  id: string;
  clientId: string;
  contractorId: string;
  scores: IScoreResult[];
  overallRanking: IContractorOverallScore;
  clientName?: string;
  isExpanded?: boolean;
}

export type IAddScoreResult = Pick<
  IScoreResult,
  | 'id'
  | 'scoreSetName'
  | 'isActive'
  | 'rankingColor'
  | 'rankingDescription'
  | 'calculatedScore'
  | 'scoreSetId'
  | 'scoreOverride'
  | 'memberType'
>;
